module.exports = __webpack_public_path__ + "img/057-businesswoman.5473df05.png";